import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import { FaTimes } from "react-icons/fa";
import axios from "axios";
import BtnLoader from "Components/Common/Loader/BtnLoader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 420,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 4,
  boxShadow: "0 25px 50px rgba(0,0,0,0.15)",
  p: 4,
};

const AddCategoryModal = ({ open, handleClose, fetchCategories }) => {
  const [name, setName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError("Category name is required.");
      return;
    }
    setError("");
    try {
      setLoading(true);
      await axios.post(
        `${process.env.REACT_APP_API_URL}/emoji-categories/create-category`,
        { name: name.trim(), isActive }
      );
      fetchCategories();
      handleModalClose();
    } catch (err) {
      console.log(err);
      setError("Failed to create category. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleModalClose = () => {
    setName("");
    setIsActive(true);
    setError("");
    handleClose();
  };

  return (
    <Modal open={open} onClose={handleModalClose}>
      <Box sx={style}>
        <IconButton
          onClick={handleModalClose}
          sx={{ position: "absolute", right: 8, top: 8, color: "#c51369" }}
        >
          <FaTimes size={14} />
        </IconButton>

        <h2 className="mb-1 text-center text-2xl font-bold text-gray-800">
          Create Category
        </h2>
        <p className="mb-5 text-center text-sm text-gray-400">
          Emoji gifts will be grouped under this category.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Category Name */}
          <div>
            <label className="mb-1.5 block text-sm font-semibold uppercase tracking-wide text-gray-500">
              Category Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                setError("");
              }}
              placeholder="e.g. Love & Romance"
              className={`w-full rounded-xl border px-3 py-2.5 text-sm text-gray-800 transition focus:outline-none focus:ring-2 focus:ring-[#c51369]/30
                ${
                  error
                    ? "border-red-400 bg-red-50"
                    : "border-gray-200 bg-gray-50 focus:border-[#c51369] focus:bg-white"
                }`}
              required
            />
            {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
          </div>

          {/* Active Status */}
          <div className="flex items-center justify-between rounded-xl border border-gray-200 bg-gray-50 px-3 py-2.5">
            <div>
              <p className="text-sm font-semibold text-gray-700">
                Active Status
              </p>
              {/* <p className="text-xs text-gray-400">
                {isActive
                  ? "Category is visible to users"
                  : "Category is hidden from users"}
              </p> */}
            </div>
            <label className="relative inline-flex cursor-pointer items-center">
              <input
                type="checkbox"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
                className="peer sr-only"
              />
              <div className="peer h-6 w-11 rounded-full bg-gray-300 transition-colors duration-200 after:absolute after:left-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:bg-white after:shadow after:transition-all after:content-[''] peer-checked:bg-[#c51369] peer-checked:after:translate-x-full" />
            </label>
          </div>

          {/* Submit */}
          {loading ? (
            <button
              type="button"
              className="flex w-full items-center justify-center rounded-xl bg-[#c51369] py-2.5"
            >
              <BtnLoader />
            </button>
          ) : (
            <button
              type="submit"
              className="w-full rounded-xl bg-[#c51369] py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#a10f5b]"
            >
              Create Category
            </button>
          )}
        </form>
      </Box>
    </Modal>
  );
};

export default AddCategoryModal;
